import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Comment } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;
@Injectable({
  providedIn: 'root'
})
export class CommentService {
  constructor(private http: HttpClient) {}

  get(CommentableType, CommentableId) {
    const query = `?CommentableType=${CommentableType}&CommentableId=${CommentableId}`;
    return this.http.get<Comment[]>(`${API}comments${query}`);
  }

  create(data) {
    return this.http.post<Comment>(`${API}comments`, data);
  }
}
